import $ from 'jquery';
import 'slick-carousel';
import { isRTL } from '../../utils/rtl';

$(function () {
    const SINGLE_SLIDE_COUNT = 1;

    const $slider = $('#top-homepage-slider');
    const $wrapper = $slider.parent('.top-homepage-slider-wrapper');
    const slideCount = $slider.children('.top-homepage-slider-card').length;
    const slidesToShow = SINGLE_SLIDE_COUNT;

    $slider.addClass('is-single-slide');

    $slider
        .on('init', function () {
            const $this = $(this);
            $this.addClass('loaded');
        })
        .slick({
            infinite: slideCount > slidesToShow,
            autoplay: true,
            dots: true,
            slidesToShow,
            slidesToScroll: slidesToShow,
            variableWidth: false,
            centerMode: false,
            prevArrow: "<button type='button' class='slick-prev'></button>",
            nextArrow: "<button type='button' class='slick-next'></button>",
            appendArrows: $wrapper,

            touchThreshold: 1000,
            customPaging() {
                return "<span class='top-homepage-slider-dot'></span>";
            },
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                    },
                },
            ],
            rtl: isRTL(),
        });
});
